import { useQuery } from '@apollo/react-hooks';
import { GET_ALLOWED_COB_LIST } from '../../../components/customer-search/queries';

export const GetListOfAllCob = () => {
  const { data } = useQuery(GET_ALLOWED_COB_LIST);
  let listOfcob: any[] = [];
  if (data !== undefined) {
    listOfcob = data.allowedBusinessAreas;
    return listOfcob;
  }
};
